import React, { Component } from 'react';
import MenuItem from 'material-ui/MenuItem';
import { CSSTransitionGroup } from 'react-transition-group';
import { SelectField } from 'redux-form-material-ui';
import { Field } from 'redux-form';
import * as validator from 'helpers/Validator';

import { getTranslatedString } from 'helpers/i18n';

class EmailSettings extends Component {
  render() {
    let {
      fields,
      selectFieldInterval,
      selectFieldStart,
      selectFieldEnd,
      preferenceParameter,
      disableSelect,
    } = this.props;

    let menuItems = [];
    for (let i = selectFieldStart; i <= selectFieldEnd; i += selectFieldInterval) {
      menuItems.push(
        <MenuItem
          value={`${i}`}
          primaryText={getTranslatedString('landlordPortal.emailSettings.menuItem', {
            numberOfDays: i,
            parameter: preferenceParameter,
          })}
          key={i}
        />
      );
    }

    return (
      <div className="row">
        <CSSTransitionGroup
          transitionName="addTransaction"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {fields.map((emailPreference, index) => (
            <div key={index} className="row">
              <div className="row" style={{ marginBottom: '0px' }}>
                <div className="col-xs-12" style={{ textAlign: 'center' }}>
                  <Field
                    name={`${emailPreference}.desired_time`}
                    component={SelectField}
                    style={{
                      fontSize: '14px',
                      maxWidth: '250px',
                      textAlign: 'left',
                      margin: 'auto',
                    }}
                    validate={[validator.required]}
                    fullWidth
                    disabled={disableSelect}
                  >
                    {menuItems}
                  </Field>
                </div>
              </div>
            </div>
          ))}
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default EmailSettings;
